import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { BusinessFeesService } from '../services/business-fees.service';
var DeleteFeeComponent = /** @class */ (function () {
    function DeleteFeeComponent(_matDialogRef, data, _feeService) {
        this._matDialogRef = _matDialogRef;
        this._feeService = _feeService;
        this.isLoading = false;
        this.serviceId = data.serviceId;
        this.businessID = data.businessID;
    }
    DeleteFeeComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._matDialogRef.backdropClick().subscribe(function () {
            _this.close({ cancelBtnClicked: true });
        });
    };
    DeleteFeeComponent.prototype.close = function (data) {
        this._matDialogRef.close(data);
    };
    DeleteFeeComponent.prototype.delete = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.isLoading = true;
                        return [4 /*yield*/, this._feeService.deleteBusinessService(this.businessID, this.serviceId)];
                    case 1:
                        _a.sent();
                        this.isLoading = false;
                        this.close({ success: true });
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        this.close({ success: false });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DeleteFeeComponent.prototype.cancel = function () {
        this.close({ cancelBtnClicked: true });
    };
    return DeleteFeeComponent;
}());
export { DeleteFeeComponent };
